import React from 'react';
import { ProcessedTourOperator, ProcessedTripItinerary } from '../contentfulModel';
import {getTickIcon, renderRichText, RichTextNode} from "../utils.tsx";

interface NotesTabProps {
    tourPackage: ProcessedTripItinerary;
    operatorColor: string;
    isMobile?: boolean;
    tourOperator: ProcessedTourOperator;
}




export const NotesTab: React.FC<NotesTabProps> = ({ tourPackage, operatorColor, isMobile, tourOperator }) => {
    const termsAndPricing = tourPackage.termsAndPricing;

    return (
        <div className="flex flex-col md:flex-row w-full h-full overflow-auto">
            {/* Mobile: Content below image, Desktop: Content on left */}
            <div className="order-last md:order-first w-full md:w-[50%] flex flex-col">
                <div
                    id="obsContainer"
                    className="w-full bg-[#F7F6F2] flex-grow p-4 md:p-8 text-left md:pt-16 md:px-[70px]"
                >
                    <div className="mb-4">
                        <div className="text-md uppercase md:text-xl md:font-medium mb-1 md:pt-2">
                            {tourPackage.category}
                        </div>
                        <h2 className="text-xl md:text-2xl font-semibold md:font-black mb-1">
                            {tourPackage.name}
                        </h2>
                        {tourPackage.subtitle && (
                            <p className="text-lg font-normal md:font-semibold">
                                {tourPackage.subtitle}
                            </p>
                        )}
                    </div>

                    <div className="mt-6 bg-white p-4 rounded-2xl mb-16">
                        <h3 className="text-xl font-semibold mb-4" style={{ color: operatorColor }}>
                            Observaciones
                        </h3>
                        <div>
                            {termsAndPricing.observations &&
                                renderRichText(
                                    getTickIcon(tourOperator.primaryColor),
                                    termsAndPricing.observations as unknown as RichTextNode
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile: Image on top, Desktop: Image on right */}
            <div className="order-first md:order-last w-full md:w-[50%] h-[200px] md:h-full">
                <div className="h-full relative">
                    <img
                        src={tourPackage.termsAndPricing?.observationImage?.file ||
                            tourPackage.mainImage?.file || ''}
                        alt="Observaciones"
                        className="w-full h-full object-cover rounded-b-2xl md:rounded-r-none md:rounded-l-2xl"
                    />
                    <img
                        src={tourOperator.logoContrast?.file || ''}
                        className="w-40 absolute hidden md:block bottom-4 right-4"
                        alt={tourOperator.name}
                    />
                </div>
            </div>
        </div>
    );
};
